export default class ArticleCard {
  constructor(component) {
    this.refs = {
      link: '.js-link',
      container: '.js-container',
    }
    this.dom = {
      $component: component,
    }
    this.state = {}

    this.mount()
  }

  mount() {
    const { dom } = this
    dom.$component.addEventListener('click', this.urlRedirect.bind(this))
  }

  urlRedirect() {
    const { dom } = this
    const link = dom.$component.querySelector(this.refs.link).href
    window.location.href = link
  }
}
